import {Form, Modal} from 'react-bootstrap'
import {AiFillQuestionCircle} from 'react-icons/ai'
import DebtInstrumentMaintenanceService from "../../../services/DebtInstrumentMaintenanceService";
import React from "react";
import { useForm } from "react-hook-form";
import {useState} from 'react'
import Alert from 'react-bootstrap/Alert'
import { toast } from 'react-toastify';
import { useContext } from "react";
import { UserContext } from "../../../UserContext";
import CommonService from "../../../services/CommonService";
import TooltipComponent from '../../../common/Tooltip';

const EditDebtInstrumentForm = (props) => {
    const user = useContext(UserContext);
    const {onModalClose, debtInfo, debtGroup} = props;
    const {register, handleSubmit,  formState: { errors }} = useForm({
        defaultValues: {
            debtInstrumentCode: debtInfo.debtInstrumentCode,
            debtInstrumentName: debtInfo.debtInstrumentName,
            activeInd: debtInfo.activeInd === 'Y' ? true : false,
            debtGroupCodeId: debtInfo.debtGroupCodeId
          }

    });
    const [errorMessage, setErrorMessage] = useState();
    const onSubmit = (data) => {

        var obj = {
            msgId: null,
            sysId: null,
            opr: "putDebtInstrumentRef",
            hdrStruct: null,
            queryParam: null,
            reqData: { "code": data.debtInstrumentCode, "debtInstrumentRef":{
                "debtInstrumentCode": data.debtInstrumentCode,
                "debtGroupCodeId": data.debtGroupCodeId,
                "debtInstrumentName": data.debtInstrumentName,
                "createUser": "SYSTEM",
                "lastUpdateUser": CommonService.getUserName(user),
                "activeInd": data.activeInd === true ? 'Y' : 'N',
            }
            },
          };
      
          DebtInstrumentMaintenanceService.updateDebtInstrument(obj)
            .then((result) => {
                if (result.data.errors && result.data.errors.length > 0){
                    setErrorMessage(result.data.errors[0].message)
                }
                else{
                    toast.success("Debt Instrument updated successfully!");
                    onModalClose();
                }
                
            });
      }
    return (
        <form onSubmit={(e) => e.preventDefault()}>
        <Modal show={true} backdrop="static" onHide={onModalClose}>
            <Modal.Header closeButton><h3>Edit Debt Instrument</h3></Modal.Header>
            <Modal.Body>
                    {errorMessage && <Alert variant="danger">
                        <p>
                            {errorMessage}
                        </p>
              </Alert>}
                <div className="control">
                    <label><span className="required">* </span>Debt Group: </label>
                    <input value={debtGroup} disabled/>
                </div>
                <div className="control">
                    <label><span className="required">* </span>Code: </label>
                    <input maxLength="4" disabled {...register('debtInstrumentCode', { required: true })}/>
                    {errors.debtInstrumentCode && <p style={{ color: 'red' }}>Code is required</p>}
                </div>
                <div className="control">
                    <label><span className="required">* </span>Name: </label>
                    <input maxLength="100" {...register('debtInstrumentName', { required: true })}/>
                    {errors.debtInstrumentName && <p style={{ color: 'red' }}>Name is required</p>}
                </div>
                <div style={{display: 'flex'}}>
                    <Form.Check type="checkbox" label="Active?" {...register('activeInd')} />
                    <TooltipComponent title="Only active values are displayed in the User Interface" id="edit-county"
                    placement="right">
                        <AiFillQuestionCircle className="help-icon mt-2" />
                    </TooltipComponent>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="custom-button-secondary  btn-secondary" onClick={onModalClose}>Cancel</button>
                <button className="custom-button" type="Submit" onClick={handleSubmit(onSubmit)}>Update</button>
            </Modal.Footer>
        </Modal>
        </form>
    )
}

export default EditDebtInstrumentForm
